// AddToLineupButton — one-tap "+" that saves a catalog track (gospel
// music, sermon, movie, video) straight into MY LINEUP. Replaces the
// old playlists picker: Lineup IS the playlist now.
import React, { useState } from "react";
import { Plus, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import { addExternalToLineup } from "../lib/lineup";
import { emitLineupChange } from "./LineupButton";
import { useAuth } from "../context/AuthContext";

export default function AddToLineupButton({
  title, youtubeId = null, url = null, poster = null, source = null, duration = null,
  size = 16, className = "",
}) {
  const { user } = useAuth();
  const [added, setAdded] = useState(false);

  const click = async (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    if (!user) { toast.error("Sign in to use your Lineup"); return; }
    if (!youtubeId && !url) { toast.error("This one can't be lined up yet"); return; }
    try {
      const res = await addExternalToLineup({
        title: title || "Untitled",
        youtube_id: youtubeId,
        url: youtubeId ? null : url,
        poster: poster || (youtubeId ? `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg` : null),
        source: source || "Video",
        duration: duration || null,
      });
      setAdded(true);
      emitLineupChange(res?.key, true, res?.count, title);
      toast.success("Added to My Lineup", { duration: 1500 });
    } catch (err) {
      if (err?.response?.status === 401) toast.error("Sign in to use your Lineup");
      else toast.error("Couldn't add to your Lineup");
    }
  };

  return (
    <button
      type="button"
      onClick={click}
      aria-label={added ? "In your Lineup" : "Add to My Lineup"}
      title={added ? "In your Lineup" : "Add to My Lineup"}
      data-testid="add-to-lineup-btn"
      className={`grid place-items-center rounded-full transition-colors ${className}`}
    >
      {added ? <Check size={size} weight="bold" /> : <Plus size={size} weight="bold" />}
    </button>
  );
}
